exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-result[data-v-5e3dad6e]{margin:0}.select-button[data-v-5e3dad6e]{font-size:1.1rem;padding:8px 2rem;margin-top:8px}.stop-name[data-v-5e3dad6e]{max-width:85%}", ""]);

// exports
